import axios from './axios';

export const beginEMACycle = async (studyName: string, participant: string) => {
  return await axios.post(`/study/${studyName}/beginEMACycle`, { studyName, participant });
}
